
import React from 'react';
import SearchWidget from '../search-widget/SearchWidget';
import Commerce from './components/Commerce';
import Contacts from './components/Contacts';
import Documents from './components/Documents';
import Content from './components/Content';
import Blog from './components/Blog';
import Spinner from '../spinner';
import { SearchResultContext } from './context/SearchResultContext';
import { PaginationBlockDesktop } from './components/PaginationBlock/PaginationBlockDesktop';
import { PaginationBlockMobile } from './components/PaginationBlock/PaginationBlockMobile';

const SearchResultPageClient = (props) => {

    const { results, activeCategory, setActiveCategory, metaData, setResults, setEndpoint, setPage, setLanguage, query, setSortOrder } = React.useContext(SearchResultContext);

    const sortOptions = [props.sortByRelevance, props.sortByAccending, props.sortByDescending];

    const renderActiveComponent = () => {
        switch (activeCategory) {
            case 'commerce':
                return <Commerce sortOptions={sortOptions} query={query} {...props} />;
            case 'documents':
                return <Documents query={query} {...props} />;
            case 'content':
                return <Content sortOptions={sortOptions} query={query} {...props} />;
            case 'blog':
                return <Blog sortOptions={sortOptions} query={query} {...props} />;
            case 'contacts':
                return <Contacts sortOptions={sortOptions} query={query} {...props} />;
            default:
                return null;
        }
    };

    const handleClick = (category) => {
        setActiveCategory(category);
        setResults(null);
        setSortOrder('');

        const params = new URLSearchParams(window.location.search);
        params.set('activeTab', category);
        params.set('q', params.get('q') ? params.get('q') : '');
        setPage(1);

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, '', newUrl);
    };

    const categoryPill = (category, label, results) => {
        return (
            <button role='tab' aria-selected={activeCategory === category} aria-controls={`panel-${category}`} id={`tab-${category}`} onClick={() => {
                if (activeCategory !== category) handleClick(category);
            }} className={`button button--rounded h-text-transform-none ${activeCategory !== category ? 'button--ghost' : ''}`}>{label} ({results || 0})</button>
        );
    };

    React.useEffect(() => {
        if (props.endpoint)
            setEndpoint(props.endpoint);
        if (props.language && props.language.name)
            setLanguage(props.language.name);
    }, [props.endpoint, props.language]);

    return (
        <section className='search-result-page-wrapper'>
            <div className='search-result-page-hero'>
                <div className='search-result-page-hero__heading'>
                    <h1>{props.heading}</h1>
                    {metaData && (
                        <p>{metaData.totalItems} {metaData.totalItems === 1 ? props.resultsForSearchTermSingular : props.resultsForSearchTermPlural} "{metaData.query}"</p>
                    )}
                </div>
                <div className='search-result-page-hero__search-field' >
                    <SearchWidget {...props.searchWidget} categories={null} suggestions={null} closeLabel={null} inputValue={query} />
                </div>
                <div role='tablist' className='search-result-page-hero__category-pills'>
                    {categoryPill('commerce', props.productSearchGroupName, metaData && metaData.productResults)}
                    {categoryPill('documents', props.documentSearchGroupName, metaData && metaData.documentResults)}
                    {categoryPill('content', props.informationSearchGroupName, metaData && metaData.contentResults)}
                    {categoryPill('blog', props.newsAndBlogsSearchGroupName, metaData && metaData.blogResults)}
                    {!props.searchHideContactsTab && categoryPill('contacts', props.contactSearchGroupName, metaData && metaData.contactResults)}
                </div>
            </div>
            {!query
                ? <></>
                : results
                    ? <div id='search-result-page-client'>
                        {renderActiveComponent()}
                        <PaginationBlockDesktop />
                        <PaginationBlockMobile />
                    </div>
                    : <div className='search-result__spinner'>
                        <Spinner size={100} />
                    </div>
            }
        </section>
    );
};

export default SearchResultPageClient;
